/** Shared formatters for the admin pages. */

export function formatNumber(value: number | null | undefined): string {
  return (value ?? 0).toLocaleString();
}

/**
 * Produce a short description of a `user_activity_events.event_data` payload.
 */
export function summarizeEventData(data: Record<string, unknown> | null | undefined): string {
  if (!data || typeof data !== 'object') return '-';
  const skip = new Set(['timestamp', 'page_path', 'page_url', 'user_agent', 'event_category']);
  const parts: string[] = [];
  for (const [key, val] of Object.entries(data)) {
    if (skip.has(key)) continue;
    if (val === '' || val === null || val === undefined) continue;
    parts.push(`${key}: ${String(val).substring(0, 40)}`);
    if (parts.length >= 3) break;
  }
  return parts.join(', ') || '-';
}
